import { catchError, switchMap } from "rxjs/operators";
import { EVALUATE_INTERACTION, logError } from "../actions";
import { of } from "rxjs";
import { ofType } from "redux-observable";
import { addQuestionPoints } from "../utils/helpers";
export default function onEvalInteractions(action$, state$) {
    return action$.pipe(ofType(EVALUATE_INTERACTION), switchMap(function(action) {
        state$.value.api.setInteraction(action.id, action.examId, !action.correct ? "wrong" : "correct", action.selectedAnswers, action.interactionType);
        if (!!state$.value.cbook.use_credit_points && action.correct) {
            addQuestionPoints(action.id, state$.value);
        }
        return [];
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "on_eval_interactions"
        }));
    }));
}
